import React, { createContext } from 'react';

import type { RibbonConfigContextValue } from './types';

export const RibbonConfigContext: React.Context<RibbonConfigContextValue | null> =
	createContext<RibbonConfigContextValue | null>(null);

export const RibbonConfigProvider = ({
	children,
	product,
}: {
	children: React.ReactNode;
	product: string;
}): React.JSX.Element => {
	return (
		<RibbonConfigContext.Provider value={{ product }}>{children}</RibbonConfigContext.Provider>
	);
};
